import React from "react";

const NewFeedPostImagesBanner: React.FC<{
  images: string[];
  post: any;
  onOpenPostModal: (postId: string) => void;
}> = ({ images, post, onOpenPostModal }) => {
  const onGoToPost = (postId: string) => {
    onOpenPostModal(postId);
  };

  return (
    <div className="relative w-full aspect-square grid grid-rows-[55%_45%] gap-1 overflow-hidden rounded-lg">
      {images.length === 1 && (
        <div className="w-full h-full overflow-hidden rounded-lg">
          <img
            src={images[0]}
            alt="post"
            className="w-full h-full object-cover"
            onClick={() => onGoToPost(post.post_id)}
          />
        </div>
      )}

      {images.length === 2 && (
        <>
          <div className="w-full h-full overflow-hidden rounded-lg">
            <img
              src={images[0]}
              alt="post"
              className="w-full h-full object-cover"
              onClick={() => onGoToPost(post.post_id)}
            />
          </div>
          <div className="w-full h-full overflow-hidden flex items-center justify-center">
            <div className="w-[90%] h-[90%] overflow-hidden rounded-lg rounded-b-lg">
              <img
                src={images[1]}
                alt="post"
                className="w-full h-full object-cover"
                onClick={() => onGoToPost(post.post_id)}
              />
            </div>
          </div>
        </>
      )}

      {images.length === 3 && (
        <>
          <div className="w-full h-full overflow-hidden rounded-lg">
            <img
              src={images[0]}
              alt="post"
              className="w-full h-full object-cover"
              onClick={() => onGoToPost(post.post_id)}
            />
          </div>
          <div className="grid grid-cols-2 w-full h-full gap-1">
            <div className="w-full h-full overflow-hidden rounded-lg">
              <img
                src={images[1]}
                alt="post"
                className="w-full h-full object-cover"
                onClick={() => onGoToPost(post.post_id)}
              />
            </div>
            <div className="w-full h-full overflow-hidden rounded-lg">
              <img
                src={images[2]}
                alt="post"
                className="w-full h-full object-cover"
                onClick={() => onGoToPost(post.post_id)}
              />
            </div>
          </div>
        </>
      )}

      {images.length === 4 && (
        <>
          <div className="w-full h-full overflow-hidden rounded-lg">
            <img
              src={images[0]}
              alt="post"
              className="w-full h-full object-cover"
              onClick={() => onGoToPost(post.post_id)}
            />
          </div>
          <div className="grid grid-cols-3 w-full h-full gap-1">
            <div className="w-full h-full overflow-hidden rounded-lg">
              <img
                src={images[1]}
                alt="post"
                className="w-full h-full object-cover"
                onClick={() => onGoToPost(post.post_id)}
              />
            </div>
            <div className="w-full h-full overflow-hidden rounded-lg">
              <img
                src={images[2]}
                alt="post"
                className="w-full h-full object-cover"
                onClick={() => onGoToPost(post.post_id)}
              />
            </div>
            <div className="w-full h-full overflow-hidden rounded-lg">
              <img
                src={images[3]}
                alt="post"
                className="w-full h-full object-cover"
                onClick={() => onGoToPost(post.post_id)}
              />
            </div>
          </div>
        </>
      )}

      {images.length > 4 && (
        <>
          <div className="w-full h-full overflow-hidden rounded-lg">
            <img
              src={images[0]}
              alt="post"
              className="w-full h-full object-cover"
              onClick={() => onGoToPost(post.post_id)}
            />
          </div>
          <div className="grid grid-cols-3 w-full h-full gap-1">
            <div className="w-full h-full overflow-hidden rounded-lg">
              <img
                src={images[1]}
                alt="post"
                className="w-full h-full object-cover"
                onClick={() => onGoToPost(post.post_id)}
              />
            </div>
            <div className="w-full h-full overflow-hidden rounded-lg">
              <img
                src={images[2]}
                alt="post"
                className="w-full h-full object-cover"
                onClick={() => onGoToPost(post.post_id)}
              />
            </div>
            <div className="relative w-full h-full overflow-hidden rounded-lg">
              <img
                src={images[3]}
                alt="post"
                className="w-full h-full object-cover"
                onClick={() => onGoToPost(post.post_id)}
              />

              <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center text-white font-bold text-xl rounded-lg">
                +{images.length - 4}
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default NewFeedPostImagesBanner;

